import React from "react";

/**
 * Large editorial section number for the top-right corner.
 * Acts as a decorative watermark — outlined serif numerals.
 *
 * variant: "light" (default, for white/beige bg) | "dark" (for charcoal bg)
 * align:   "right" (default) | "left"
 */
export default function SectionNumber({
  n,
  variant = "light",
  align = "right",
  className = "",
}) {
  const isDark = variant === "dark";
  const stroke = isDark
    ? "rgba(255, 255, 255, 0.18)"
    : "rgba(217, 4, 41, 0.22)";

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none select-none absolute top-6 sm:top-10 ${
        align === "right" ? "right-4 sm:right-8 lg:right-12" : "left-4 sm:left-8 lg:left-12"
      } z-0 ${className}`}
    >
      <span
        className="font-serif leading-none font-extralight tracking-tighter block"
        style={{
          fontSize: "clamp(3.5rem, 9vw, 8rem)",
          color: "transparent",
          WebkitTextStroke: `1.5px ${stroke}`,
          textStroke: `1.5px ${stroke}`,
        }}
      >
        {n}
      </span>
    </div>
  );
}
